import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal } from 'sa-ui';
import messages from './simulatedCorrectionMessages';

const SimulatedCorrectionRemoveConfirmationModal = props => (
  <Modal
    show={props.show}
    onClose={props.onClose}
    title={props.intl.formatMessage(messages.removeTitle)}
    icon="ti-help-alt"
    buttons={[
      { onClick: props.onClose, label: props.intl.formatMessage(messages.close) },
      {
        onClick: props.onConfirm,
        label: props.intl.formatMessage(messages.confirm),
        primary: true,
      },
    ]}
    message={props.intl.formatMessage(messages.confirmRemove)}
  />
);

SimulatedCorrectionRemoveConfirmationModal.propTypes = {};

export default injectIntl(SimulatedCorrectionRemoveConfirmationModal);
